import { Badge } from "@/components/shadcn/badge";
import { twMerge } from "tailwind-merge";

type StatusLabelProps = {
  status: string;
  pendingActivation?: boolean;
  className?: string;
};

const StatusPill = ({
  status,
  pendingActivation,
  className = "",
}: StatusLabelProps) => {
  if (!status) return null;

  const normalizedStatus = status.toLowerCase();
  const isGreen = ["active", "trialing", "paid", "published", "valid"].includes(
    normalizedStatus,
  );
  const isYellow = [
    "paused",
    "pending",
    "publishable",
    "manual payment sent",
  ].includes(normalizedStatus);
  const isRed = [
    "expired",
    "deleted",
    "activationerror",
    "canceled",
    "inactive",
  ].includes(normalizedStatus);
  const isPurple = ["refunded"].includes(normalizedStatus);

  const isGray = !isGreen && !isYellow && !isRed;

  return (
    <Badge
      className={twMerge(
        "capitalize",
        isGray && "bg-muted text-foreground",
        isGreen && "bg-[#154337] text-[#15FFAB]",
        isYellow && "bg-[#413525] text-yellow-500",
        isRed && "bg-[#422227] text-[#FC5A5A]",
        isPurple && "bg-primary/75 text-white",
        className,
      )}
    >
      {pendingActivation ? "Activating..." : normalizedStatus}
    </Badge>
  );
};

export default StatusPill;
